
export enum STATES {
    FAILED = "FAILED",
    SUCCEEDED = "SUCCEEDED",
    RUNNING = "RUNNING",
    STOPPED = "STOPPED"
}
